import { combineReducers } from "redux";
import posts from "./posts";
import authReducer from "./auth";
import courses from "./courses";

export default combineReducers({ posts, courses, authReducer });
